// extracted by mini-css-extract-plugin
export var active = "_g3-7";
export var blink = "_g3-8";
export var dropDownSelector = "_g3-4";
export var dropDownWrapper = "_g3-3";
export var fakeCursor = "_g3-6";
export var fontSizeButton = "_g3-9";
export var formQuillEditor = "_g3-0";
export var pressed = "_g3-a";
export var qlBlank = "_g3-1";
export var textFormattingToolbar = "_g3-2";
export var textToolbarOption = "_g3-5";